// Archivio della pagina "Podcast & Video" (template-parts/podcast-video/grid.php):
// interamente client-side, a differenza di assets/js/archivio-collaborazioni.js —
// qui non c'è un CPT/endpoint REST da interrogare, il repeater podcast_video_items
// vive sulla Pagina stessa e ogni media è già nel markup. Quattro comportamenti
// sullo stesso set di card:
// - filtro per tipo (chip "Tutti"/Podcast/Video/TV) e ricerca testuale libera
//   (titolo + testo della card), combinati con AND: una card resta visibile
//   solo se soddisfa entrambi;
// - "Carica altri media"/"Mostra meno" (assets/js/load-more-grid.js, stesso
//   principio di assets/js/gallery.js): mostra solo le prime
//   INITIAL_COUNT card del sottoinsieme filtrato/cercato, le altre restano
//   [hidden] finché non si preme il bottone;
// - vista griglia/elenco: solo una classe sul contenitore, nessun effetto su
//   quali card sono visibili.
import { createLoadMoreGrid } from "./load-more-grid";

const INITIAL_COUNT = 9;
const LOAD_INCREMENT = 9;
const SEARCH_DEBOUNCE_MS = 300;

function debounce(fn, delay) {
    let timer = null;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}

function initPodcastVideoSection(section) {
    const grid = section.querySelector("[data-podcast-video-grid]");

    if (!grid) {
        return;
    }

    const items = Array.from(grid.querySelectorAll("[data-podcast-video-item]"));
    const filterButtons = Array.from(section.querySelectorAll("[data-podcast-video-filter]"));
    const viewButtons = Array.from(section.querySelectorAll("[data-podcast-video-view]"));
    const searchInput = section.querySelector("[data-podcast-video-search-input]");
    const countLabel = section.querySelector("[data-podcast-video-count]");
    const emptyMessage = section.querySelector("[data-podcast-video-empty]");
    const loadMoreWrap = section.querySelector("[data-podcast-video-load-more-wrap]");
    const loadMoreButton = section.querySelector("[data-podcast-video-load-more]");
    const showLessButton = section.querySelector("[data-podcast-video-show-less]");
    const shownCountLabel = section.querySelector("[data-podcast-video-shown-count]");

    // Titolo + testo di ogni card, già in minuscolo: calcolati una sola volta
    // qui invece che ad ogni digitazione nel campo di ricerca.
    const searchHaystacks = new WeakMap();
    items.forEach((item) => {
        const title = item.querySelector(".podcast-video-archivio__card-title");
        const text = item.querySelector(".podcast-video-archivio__card-text");
        searchHaystacks.set(item, `${title ? title.textContent : ""} ${text ? text.textContent : ""}`.toLowerCase());
    });

    let currentFilter = "";
    let currentSearch = "";

    function matchesFilter(item) {
        if (currentFilter && item.dataset.podcastVideoTipo !== currentFilter) {
            return false;
        }

        if (currentSearch && !searchHaystacks.get(item).includes(currentSearch)) {
            return false;
        }

        return true;
    }

    const loadMoreGrid = createLoadMoreGrid({
        getItems: () => items.filter(matchesFilter),
        initialCount: INITIAL_COUNT,
        loadIncrement: LOAD_INCREMENT,
        loadMoreWrap,
        loadMoreButton,
        showLessButton,
        onRender({ shown, total }) {
            if (countLabel) {
                const label = total === 1 ? "episodio" : "episodi";
                countLabel.textContent = `${total} ${label}`;
            }

            if (emptyMessage) {
                emptyMessage.hidden = total > 0;
            }

            if (shownCountLabel) {
                shownCountLabel.textContent = total > INITIAL_COUNT ? `Mostrati ${shown} di ${total} media` : "";
            }
        },
    });

    function applyFilter() {
        // Le card fuori dal filtro corrente non compaiono nell'array che
        // createLoadMoreGrid() pagina (getItems() sopra): senza questo passo
        // resterebbero visibili così com'erano prima del cambio filtro,
        // perché render() non le tocca mai.
        items.forEach((item) => {
            if (!matchesFilter(item)) {
                item.hidden = true;
            }
        });

        loadMoreGrid.reset();
    }

    filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
            if (button.classList.contains("is-active")) {
                return;
            }

            currentFilter = button.dataset.podcastVideoFilterValue || "";
            filterButtons.forEach((btn) => btn.classList.toggle("is-active", btn === button));
            applyFilter();
        });
    });

    if (searchInput) {
        const debouncedApplyFilter = debounce(() => {
            currentSearch = searchInput.value.trim().toLowerCase();
            applyFilter();
        }, SEARCH_DEBOUNCE_MS);

        searchInput.addEventListener("input", debouncedApplyFilter);
    }

    viewButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const view = button.dataset.podcastVideoView;

            if (button.classList.contains("is-active")) {
                return;
            }

            viewButtons.forEach((btn) => btn.classList.toggle("is-active", btn === button));
            grid.classList.toggle("podcast-video-archivio__grid--list", view === "list");
        });
    });

    loadMoreGrid.render();
}

export function initPodcastVideo() {
    document.querySelectorAll("[data-podcast-video]").forEach(initPodcastVideoSection);
}
